import React, {
    createContext,
    useCallback,
    useContext,
    useMemo,
    useRef,
    useState,
} from 'react';

const HoursFieldDraftContext = createContext({
    report_committable_draft: () => {},
    has_committable_draft: false,
});

/**
 * Tracks HoursField inputs that hold a typed-but-not-yet-committed HH:MM.
 * Used so Save can stay enabled for that case, but stay disabled when empty.
 */
export function HoursFieldDraftProvider({ children }) {
    const drafts_ref = useRef(new Map());
    const [has_committable_draft, set_has_committable_draft] = useState(false);

    const report_committable_draft = useCallback((field_key, committable) => {
        const drafts = drafts_ref.current;
        if (committable) {
            drafts.set(field_key, true);
        } else {
            drafts.delete(field_key);
        }
        const next = drafts.size > 0;
        set_has_committable_draft((prev) => (prev === next ? prev : next));
    }, []);

    const value = useMemo(() => ({
        report_committable_draft,
        has_committable_draft,
    }), [report_committable_draft, has_committable_draft]);

    return (
        <HoursFieldDraftContext.Provider value={ value }>
            {children}
        </HoursFieldDraftContext.Provider>
    );
}

export function useHoursFieldDraft() {
    return useContext(HoursFieldDraftContext);
}
